import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
// import {
//   LinkIcon
// } from '../../components'
import Styles from './IyvListTable.css'


@CSSModules(Styles, {allowMultiple:true})
export default class IyvListCompareSelectIcon extends Component {
  static propTypes = {
    shareclass: PropTypes.object.isRequired,
    clickCompareSelect: PropTypes.func.isRequired,
    getCompareSelectStyles: PropTypes.func.isRequired,
    cart: PropTypes.object,
    displayLabel: PropTypes.bool
  }
  //
  constructor(props) {
    super(props)
  }
  //
  render() {
    const compareSelectStyles = this.props.getCompareSelectStyles(
      this.props.cart,
      this.props.shareclass.investment_vehicle_id
    )
    //
    return <span onClick={() => { this.props.clickCompareSelect(this.props.shareclass) }}>
      <span>
        <i
          className={compareSelectStyles.className}
          styleName={compareSelectStyles.styleName}
        />
      </span>
      {
        this.props.displayLabel ?
          <span>
            Compare
          </span> :
          null
      }
    </span>
  }
}